var map = {
	"./Resume.pdf": 9,
	"./about_me.jpeg": 8,
	"./claro-0.JPG": 19,
	"./claro-1.JPG": 20,
	"./claro-2.JPG": 21,
	"./claro.JPG": 22,
	"./expensify.JPG": 23,
	"./holamundo.JPG": 24,
	"./hub-cenefa.JPG": 25,
	"./hub-dashboard-1.JPG": 26,
	"./hub-dashboard.JPG": 27,
	"./lacasitachaupin.JPG": 28,
	"./loruki.JPG": 29,
	"./portfolio.JPG": 30,
	"./scotiabank-1.JPG": 31,
	"./scotiabank-2.JPG": 32,
	"./scotiabank.JPG": 33,
	"./shoppinglist.JPG": 34,
	"./starwars.JPG": 35,
	"./wall-prat-1.JPG": 36,
	"./wall-prat-2.JPG": 37,
	"./wall-prat.JPG": 38,
	"./werking-0.JPG": 39,
	"./werking-1.JPG": 40,
	"./werking-2.JPG": 41,
	"./werking-dashboard-1.JPG": 42,
	"./werking-dashboard.JPG": 43,
	"./werking-wheather-1.JPG": 44,
	"./werking-wheather-2.JPG": 45,
	"./werking-wheather-3.JPG": 46,
	"./werking-wheather.JPG": 47,
	"./werking.JPG": 48,
	"./workcafe-0.JPG": 49,
	"./workcafe-1.JPG": 50,
	"./workcafe-2.JPG": 51,
	"./workcafe-dashboard-1.JPG": 52,
	"./workcafe-dashboard-2.JPG": 53,
	"./workcafe-dashboard.JPG": 54,
	"./workcafe.JPG": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;